import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Pagination from "../../components/Pagination";
import BackendLayout from "../../layouts/BackendLayout";
import { useDocumentTitle } from "../../hooks";
import { getInspectionTemplateSearchPage } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import { INSPECTION_TEMPLATE_MASTER_SEARCH } from "../../constants/routes";
import { PageTitle } from "../../components/admin";
import { useGetLogs } from "../../hooks";
import PageAlert from "../../components/alerts/PageAlert";
import {
  clearPageLoading,
  resetAlert,
  setPageLoading,
} from "../../store/actions";
import {
  API_INSPECTION_TEMPLATE_DOWNLOAD_LOG,
  API_GET_INSPECTION_TEMPLATE_LOGS,
} from "../../constants/api";
import { LogItem, LogPanelFilter } from "../../components/logs";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import {INSPECTION_TEMPLATE_MASTER_SEARCH_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";
import {RedirectAlert} from "../../components";

export default function InspectionTemplateSearchPage() {
  useRedirectPage(INSPECTION_TEMPLATE_MASTER_SEARCH_PAGE);
  const breadcrumb = getRouteBreadcrumb(INSPECTION_TEMPLATE_MASTER_SEARCH);
  const dispatch = useDispatch();
  useDocumentTitle("点検テンプレートマスタ更新履歴検索 - 点検王");

  const setInspectionTemplateHistorySearchPageSettings = async (e) => {
    dispatch(setPageLoading());
    const pageSettings = await getInspectionTemplateSearchPage();
    dispatch(setPageSettings(pageSettings));
    dispatch(clearPageLoading());
  };
  useEffect(() => {
    setInspectionTemplateHistorySearchPageSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const BUTTON_SEARCH_LOGS = "button__search-template-logs";
  const [reload, setReload] = useState(0);
  const {
    errors,
    logs,
    page,
    perPage,
    totalCount,
    dataSearch,
    setErrors,
    setPage,
    setPerPage,
    SetDataSearch,
  } = useGetLogs(
    reload,
    API_GET_INSPECTION_TEMPLATE_LOGS,
    "inspection_template_history_search",
    BUTTON_SEARCH_LOGS
  );

  const handleSubmitSearch = () => {
    dispatch(resetAlert());
    setErrors({});
    setReload(reload + 1);
  };

  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <PageTitle title="点検テンプレートマスタ更新履歴検索" />
      <div className="history-search__content">
        <p className="font-light xl:mb-3 mb-2">
          50MB までのxlsxファイルをダウンロードすることができます。
        </p>
        <RedirectAlert />
        <PageAlert />
        <div className="w-fit pr-[24px] lg:pr-0">
          <LogPanelFilter
            formData={dataSearch}
            setFormData={SetDataSearch}
            handleSubmitSearch={handleSubmitSearch}
            errors={errors}
            buttonId={BUTTON_SEARCH_LOGS}
          />
          <div className="machine-infor__list">
            <LoadingSpinner component="inspection_template_history_search" />
            {logs.length > 0 ? (
              logs.map((item, index) => (
                <LogItem
                  key={index}
                  item={item}
                  apiUrl={API_INSPECTION_TEMPLATE_DOWNLOAD_LOG}
                />
              ))
            ) : (
              <p>
                該当する検索結果が見つかりませんでした。別の検索条件をお試しください。
              </p>
            )}
          </div>
          <div className="md:mt-3 xl:mt-6">
            <Pagination
              setPage={setPage}
              currentPage={page}
              pageSize={perPage}
              totalCount={totalCount}
              showIndex={totalCount > 0}
              setPageSize={totalCount > 0 ? setPerPage : null}
            />
          </div>
        </div>
      </div>
    </BackendLayout>
  );
}
